module.exports = __webpack_public_path__ + "static/build-1-43fa4ec8c026539855e596fb35474039.png";